module.exports = __webpack_public_path__ + "media/application/images/NPA-75ae231ca2e51842e1f7867883feb572.png";